import './FormSection.scss';

import { Card } from 'antd';
import { ReactNode } from 'react';

/**
 * Wrapper genérico de sección de formulario con título y Card de Ant Design.
 *
 * metadata:
 * - feature: forms.section-wrapper
 * - purpose: reemplaza el patrón repetido <Card className="XxxFormSection"><div className="XxxFormTitle">{title}</div>...</Card>
 *   presente en ShipmentForm, ReceptionForm y ServiceOrderForm
 */
interface FormSectionProps {
  title?: string;
  className?: string;
  children: ReactNode;
}

const FormSection = ({ title, className, children }: FormSectionProps) => (
  <Card className={`FormSection ${className || ''}`}>
    {title && <div className="FormSectionTitle">{title}</div>}
    {children}
  </Card>
);

export default FormSection;
